import { CreateTagForm, UpdateTagForm, TagListResponse, TagData } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/tag';

export class TagApi {
    public static async create(tag: CreateTagForm): Promise<void> {
        await axios.post(BASE_URL, { tag });
    }

    public static async update(id: string, tag: UpdateTagForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { tag });
    }

    public static async remove(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }

    public static async getList(): Promise<TagData[]> {
        const res = await axios.get<TagListResponse>(BASE_URL);

        return res.data.tags;
    }
}
